import { FormControl } from '@angular/forms';
 
export function validatePhoneNumber(control: FormControl) {
    const phoneNumberRegexPatterns = [
        new RegExp('^((0\\d{1,3}(\\s|\\/|\\.)?)|((\\+|00)\\d{2,3}(\\s|\\.)?\\d{1,3}(\\s|\\.)?))\\d{2,3}(\\s|\\.)?\\d{2}(\\s|\\.)?\\d{2}$')
        // new RegExp('^(0)[0-9]{1}[\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(04)?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(\\+)[0-9]{2}[\\s]?[0-9][\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(00)[0-9]{2}[\\s]?[0-9][\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(\\+)[0-9]{2}[\\s]?(4)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(00)[0-9]{2}[\\s]?(4)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(0)[0-9]{1}[/][0-9]{3}[.][0-9]{2}[.][0-9]{2}$'),
        // new RegExp('^(0)[0-9]{1}[.][0-9]{3}[.][0-9]{2}[.][0-9]{2}$'),
        // new RegExp('^(\\\+)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
    ];
    const phoneNumber = control.value;
    if (phoneNumber) {
        for (const pattern of phoneNumberRegexPatterns) {
            if (pattern.test(phoneNumber)) {
                return null;
            }
        }
        return {
            phoneNoPattern: {
                phoneNoValue: phoneNumber
            }
        };
    } else {
        return null;
    }
}